module.exports = __webpack_public_path__ + "img/img_supplier_slr@2x.c983d1fd.png";